import { render, staticRenderFns } from "./quotationToolsCost-add-or-update.vue?vue&type=template&id=8c778352"
import script from "./quotationToolsCost-add-or-update.vue?vue&type=script&lang=js"
export * from "./quotationToolsCost-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./quotationToolsCost-add-or-update.vue?vue&type=style&index=0&id=8c778352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports